import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Skeleton } from "@/components/ui/skeleton";

const TITLES = {
  rice: { title: "Rice", sub: "Sona Masoori, Basmati, Ponni, Brown Rice & more" },
  grains: { title: "Grains", sub: "Wheat, Millets, Ragi, Jowar, Bajra & more" },
  pulses: { title: "Pulses & Dal", sub: "Toor, Moong, Chana, Urad, Masoor" },
  all: { title: "Shop All", sub: "Rice, grains & pulses" },
};

export default function Shop() {
  const { category = "all" } = useParams();
  const [products, setProducts] = useState(null);

  useEffect(() => {
    const q = category === "all" ? "" : `?category=${category}`;
    api.get(`/products${q}`).then(({ data }) => setProducts(data)).catch(() => setProducts([]));
  }, [category]);

  const meta = TITLES[category] || TITLES.all;

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-10">
      <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tight" data-testid="shop-title">{meta.title}</h1>
      <p className="text-muted-foreground mt-1">{meta.sub}</p>
      <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="product-grid">
        {products === null
          ? Array.from({ length: 8 }).map((_, i) => <Skeleton key={i} className="aspect-[3/4] rounded-lg" />)
          : products.length === 0
            ? <div className="col-span-full text-center text-muted-foreground py-16">No products found.</div>
            : products.map((p) => <ProductCard key={p.product_id} product={p} />)}
      </div>
    </div>
  );
}
